import React, { useState, useEffect, useRef } from 'react';
import './PlanGallery.css';

const PlanGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const sliderRef = useRef(null);

  const plans = [
    { id: 1, src: '/assets/img/Plan/t1.png', alt: 'Floor Plan 1' },
    { id: 2, src: '/assets/img/Plan/t2.png', alt: 'Floor Plan 2' },
    { id: 3, src: '/assets/img/Plan/t3.png', alt: 'Floor Plan 3' },
    { id: 4, src: '/assets/img/Plan/t4.png', alt: 'Floor Plan 4' }
  ];

  // Auto slide effect
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % plans.length);
      }, 3000); // Change slide every 3 seconds

      return () => clearInterval(interval);
    }
  }, [isPaused, plans.length]);

  const openZoom = (plan) => {
    setSelectedImage(plan);
  };

  const closeZoom = () => {
    setSelectedImage(null);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + plans.length) % plans.length);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % plans.length);
  };

  return (
    <>
      <div className="plan-slider-container">
        <div 
          className="plan-slider-wrapper"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          ref={sliderRef}
        >
          <div 
            className="plan-slider-track"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {plans.map((plan) => (
              <div key={plan.id} className="plan-slide">
                <div className="plan-card" onClick={() => openZoom(plan)}>
                  <div className="plan-img-wrapper">
                    <img src={plan.src} alt={plan.alt} className="plan-img" />
                    <div className="plan-overlay">
                      <div className="lens-icon">
                        <i className="fas fa-search-plus"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button className="slider-arrow slider-arrow-left" onClick={goToPrevious}>
            <i className="fas fa-chevron-left"></i>
          </button>
          <button className="slider-arrow slider-arrow-right" onClick={goToNext}>
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>

        {/* Slider Dots */}
        <div className="slider-dots">
          {plans.map((_, index) => (
            <button
              key={index}
              className={`slider-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>

      {/* Zoom Modal */}
      {selectedImage && (
        <div className="zoom-modal" onClick={closeZoom}>
          <div className="zoom-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeZoom}>
              <i className="fas fa-times"></i>
            </button>
            <img src={selectedImage.src} alt={selectedImage.alt} className="zoomed-img" />
          </div>
        </div>
      )}
    </>
  );
};

export default PlanGallery;
